// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8eOCa","col":"styles_col__1ONqM","actions":"styles_actions__1MG3r","conflict":"styles_conflict__M0Gkw"};